import {Component, HostBinding} from '@angular/core';
import {NotificationsService} from '@catcore/services';
import {Message} from 'primeng/primeng';

const componentBaseName = 'notifications';
const defaultClassNames = ['cat-' + componentBaseName + '-component'].join(' ');

@Component({
  selector: 'cat-notifications',
  templateUrl: './notifications.component.html',
})
export class NotificationsComponent {
  @HostBinding('class') classNames = defaultClassNames;
  messages: Message[] = [];
  cached: Message[] = [];
  timeToLife = 5 * 1000;
  baseZIndex = 1400;

  constructor(private notificationService: NotificationsService) {
    notificationService.messageState.subscribe((state) => {
      if (state.messages.length > 0) {
        this.cached.push(state.messages.pop());

        this.messages = [];

        this.cached.forEach((message) => {
          this.messages.push(message);
        });

      }
    });
  }

  onClose($event) {
    const filtered = [];
    this.cached.forEach((cachedMessage) => {
      if ($event.message !== cachedMessage) {
        filtered.push(cachedMessage);
      }
    });

    this.cached = filtered;
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/core/components/notifications/notifications.component.ts